module.exports = __webpack_public_path__ + "static/media/card3.1192f5d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/card3.png
// module id = 138
// module chunks = 0